import _asyncToGenerator from "/vercel/path0/apps/legacy-open/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/apps/legacy-open/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/apps/legacy-open/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/apps/legacy-open/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/vercel/path0/apps/legacy-open/node_modules/@babel/runtime/regenerator";
import { withToken } from '@/lib/http-client';
import Logger from '@/lib/logger';
var AuthClientStoreError = new Error('AuthClient: store not set');

var AuthClient = /*#__PURE__*/function () {
  function AuthClient() {
    _classCallCheck(this, AuthClient);

    _defineProperty(this, "revokeTokenPromise", null);

    _defineProperty(this, "store", null);
  }

  _createClass(AuthClient, [{
    key: "get",
    value: function get(url, config) {
      return this.catchExpiredToken(function (client) {
        return client.get(url, config);
      });
    }
  }, {
    key: "patch",
    value: function patch(url, data, config) {
      return this.catchExpiredToken(function (client) {
        return client.patch(url, data, config);
      });
    }
  }, {
    key: "post",
    value: function post(url, data, config) {
      return this.catchExpiredToken(function (client) {
        return client.post(url, data, config);
      });
    }
  }, {
    key: "delete",
    value: function _delete(url, config) {
      return this.catchExpiredToken(function (client) {
        return client["delete"](url, config);
      });
    }
  }, {
    key: "setStore",
    value: function setStore(store) {
      this.store = store;
    }
  }, {
    key: "catchExpiredToken",
    value: function () {
      var _catchExpiredToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(request) {
        var makeRequest;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.store) {
                  _context2.next = 2;
                  break;
                }

                throw AuthClientStoreError;

              case 2:
                makeRequest = /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return request(withToken());

                          case 3:
                            return _context.abrupt("return", _context.sent);

                          case 6:
                            _context.prev = 6;
                            _context.t0 = _context["catch"](0);
                            throw Logger.error(_context.t0);

                          case 9:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[0, 6]]);
                  }));

                  return function makeRequest() {
                    return _ref.apply(this, arguments);
                  };
                }();

                return _context2.abrupt("return", makeRequest());

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function catchExpiredToken(_x) {
        return _catchExpiredToken.apply(this, arguments);
      }

      return catchExpiredToken;
    }()
  }]);

  return AuthClient;
}();

export default new AuthClient();